import { Clock3 } from "lucide-react";
import "./SalarNowGroceries.css";

type GroceryProduct = {
    name: string;
    category: string;
    image: string;
};

const groceryProducts: GroceryProduct[] = [
    { name: "Fresh Vegetables", category: "Vegetables", image: "/assets/images/groceries/shop-1.png" },
    { name: "Fresh Fruits", category: "Fruits", image: "/assets/images/groceries/shop-2.png" },
    { name: "Milk & Dairy", category: "Dairy", image: "/assets/images/groceries/shop-3.png" },
    { name: "Bread & Bakery", category: "Bakery", image: "/assets/images/groceries/shop-4.png" },
    { name: "Rice & Grains", category: "Staples", image: "/assets/images/groceries/shop-5.png" },
    { name: "Cooking Oils", category: "Kitchen", image: "/assets/images/groceries/shop-6.png" },
    { name: "Snacks & Namkeen", category: "Snacks", image: "/assets/images/groceries/shop-7.png" },
    { name: "Biscuits & Cookies", category: "Bakery", image: "/assets/images/groceries/shop-8.png" },
    { name: "Tea & Coffee", category: "Beverages", image: "/assets/images/groceries/shop-9.png" },
    { name: "Cold Drinks & Juices", category: "Beverages", image: "/assets/images/groceries/shop-10.png" },
    { name: "Breakfast & Cereals", category: "Breakfast", image: "/assets/images/groceries/shop-11.png" },
    { name: "Dry Fruits & Nuts", category: "Healthy Foods", image: "/assets/images/groceries/shop-12.png" },
    { name: "Atta & Flour", category: "Staples", image: "/assets/images/groceries/shop-13.png" },
    { name: "Pulses & Lentils", category: "Staples", image: "/assets/images/groceries/shop-14.png" },
    { name: "Spices & Masalas", category: "Kitchen", image: "/assets/images/groceries/shop-15.png" },
    { name: "Sauces & Spreads", category: "Condiments", image: "/assets/images/groceries/shop-16.png" },
    { name: "Instant Food", category: "Quick Meals", image: "/assets/images/groceries/shop-17.png" },
    { name: "Frozen Food", category: "Frozen", image: "/assets/images/groceries/shop-18.png" },
    { name: "Household Essentials", category: "Household", image: "/assets/images/groceries/shop-19.png" },
    { name: "Personal Care", category: "Daily Care", image: "/assets/images/groceries/shop-20.png" },
];

const SalarNowGroceries = () => {
    return (
        <section className="salar-now">
            <div className="salar-now-container">
                <div className="salar-now-header">
                    <div className="salar-now-heading">
                        <div className="salar-now-kicker">
                            <span className="salar-now-badge">SALAR NOW</span>
                            <span className="salar-now-delivery">
                                <Clock3 size={13} strokeWidth={1.9} />
                                Quick Commerce
                            </span>
                        </div>
                        <h2>Everyday groceries, ready when you are.</h2>
                        <p>Shop fresh food, daily essentials and pantry favourites through Salar Now.</p>
                    </div>
                </div>

                <div className="salar-now-panel">
                    {groceryProducts.map((product) => (
                        <button type="button" className="salar-now-item" key={product.image}>
                            <span className="salar-now-image">
                                <img src={product.image} alt={product.name} />
                            </span>
                            <span className="salar-now-info">
                                <small>{product.category}</small>
                                <strong>{product.name}</strong>
                            </span>
                        </button>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default SalarNowGroceries;